import { render, staticRenderFns } from "./ReportDealerConnectedSummaries.vue?vue&type=template&id=58c47bfe&"
import script from "./ReportDealerConnectedSummaries.vue?vue&type=script&lang=js&"
export * from "./ReportDealerConnectedSummaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports